import React from 'react';

import TRANSLATIONS from '../../../translations/translations@default.json';

const ProductDataSheet = ({ ProductDatasheetPdfUrl, customCats }) => {
	if (!ProductDatasheetPdfUrl) {
		return null;
	}
	return (
		<a
			href={ProductDatasheetPdfUrl}
			alt="product data sheet"
			target="_blank"
			rel="noopener noreferrer"
			data-tag-name="product-data-sheet-clicked"
			className={`font-bold block text-body-xs text-cta-action ${
				customCats ? 'ml-5 text-right' : 'ml-0'
			}`}>
			{TRANSLATIONS.productList.productCard.energyLabel.productDataSheet}
		</a>
	);
};

export default ProductDataSheet;
